(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contributor", {
                parent: "entity",
                url: "/lebaniego-contributor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContributor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante.html",
                        controller:
                            "LebaniegoYearContributorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                },
            })
            .state("lebaniego-contributor.new", {
                parent: "lebaniego-contributor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-new.html",
                        controller: "LebaniegoYearContributorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contributor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contributor.edit", {
                parent: "lebaniego-contributor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContributor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-detail.html",
                        controller: "LebaniegoYearContributorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contributor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContributor",
                        function ($stateParams, LebaniegoYearContributor) {
                            return LebaniegoYearContributor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            });
    }
})();